import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

interface ResetPasswordDialogProps {
  open: boolean;
  username: string;
  onCancel: () => void;
  onConfirm: (password: string) => void;
  error?: string | null;
}

export const ResetPasswordDialog: React.FC<ResetPasswordDialogProps> = ({
  open, username, onCancel, onConfirm, error,
}) => {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open) setPassword('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Set a new password for <strong>{username}</strong>.
        </DialogContentText>
        {error && <DialogContentText color="error">{error}</DialogContentText>}
        <TextField
          label="New password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          size="small"
          fullWidth
          autoFocus
          helperText="At least 6 characters"
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" disabled={password.length < 6} onClick={() => onConfirm(password)}>
          Set Password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
